import { render } from "./DefaultExpirationDisplay.vue?vue&type=template&id=e959cb36&scoped=true"
import script from "./DefaultExpirationDisplay.vue?vue&type=script&lang=js"
export * from "./DefaultExpirationDisplay.vue?vue&type=script&lang=js"

import "./DefaultExpirationDisplay.vue?vue&type=style&index=0&id=e959cb36&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e959cb36"]])

export default __exports__